import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Версия лендинга уходит параметром визита в Метрику. Старая версия живёт
// в корне домена, новая — в /new; параметр позволяет сравнить их конверсии
// одним отчётом, не разбирая URL фильтрами.
if (window.ym) {
  window.ym(108320505, "params", { version: "base" });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
